export const fixLineBreaks = (input: string) => {
  return input.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
}
